export default "__VITE_ASSET__bd36ba98__"